export default __webpack_public_path__ + "static/media/Gorbel.d2d6a627.png";